import { render } from "./UserUpdatePhoto.vue?vue&type=template&id=e7f55336&scoped=true"
import script from "./UserUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./UserUpdatePhoto.vue?vue&type=script&lang=js"

import "./UserUpdatePhoto.vue?vue&type=style&index=0&id=e7f55336&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7f55336"]])

export default __exports__